import { useEffect } from 'react';

export default function useClickOutside(ref, onOutside) {
  useEffect(() => {
    function onPointerDown(e) {
      if (!ref.current) return;
      if (ref.current.contains(e.target)) return;
      onOutside();
    }

    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [ref, onOutside]);
}

